const badges = [
  {
    image: '/assets/img/badge-largest-america.webp',
    alt: 'Largest in the US',
    label: 'Largest',
    desc: 'In the US',
    imageClass: 'w-12 h-10',
  },
  {
    image: '/assets/img/badge-iso-tight.webp',
    alt: 'ISO Certified',
    label: 'ISO',
    desc: 'Certified Quality',
    imageClass: 'w-9 h-9',
    // The ISO mark reads best on a white disc rather than the grey card.
    circle: true,
  },
  {
    image: '/assets/img/badge-quality-guaranteed.webp',
    alt: 'Quality Guaranteed',
    label: 'Quality Guarantee',
    desc: 'Built to Last',
    imageClass: 'w-10 h-10',
  },
];

export default function TrustBadges() {
  return (
    <section className="bg-white border-b border-gray-100 py-10">
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {badges.map((badge, i) => (
            <div
              key={i}
              className="flex items-center gap-4 bg-gray-50 rounded-xl px-6 py-5"
            >
              {badge.circle ? (
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center flex-shrink-0">
                  <img
                    src={badge.image}
                    alt={badge.alt}
                    className={`${badge.imageClass} object-contain`}
                  />
                </div>
              ) : (
                <img
                  src={badge.image}
                  alt={badge.alt}
                  className={`${badge.imageClass} object-contain flex-shrink-0`}
                />
              )}
              <div className="text-left">
                <div className="text-base font-bold text-gray-900 leading-tight">
                  {badge.label}
                </div>
                <div className="text-sm text-gray-500 mt-0.5">{badge.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
